import React, { useEffect, useLayoutEffect, useRef } from 'react';
export const Widget = _ref => {
  let {
    fieldId,
    widgetHtml,
    value,
    onChange
  } = _ref;
  const iframeRef = useRef(null);
  const onChangeRef = useRef(onChange);
  useLayoutEffect(() => {
    onChangeRef.current = onChange;
  });
  const valueRef = useRef(value);
  useLayoutEffect(() => {
    valueRef.current = value;
  });
  useEffect(() => {
    const handler = event => {
      var _event$data;
      if (((_event$data = event.data) == null ? void 0 : _event$data.fieldId) !== fieldId) {
        return;
      }
      if (event.data.type === 'READY') {
        var _iframeRef$current;
        (_iframeRef$current = iframeRef.current) == null || (_iframeRef$current = _iframeRef$current.contentWindow) == null || _iframeRef$current.postMessage({
          type: 'INIT',
          fieldId,
          value: valueRef.current ?? {}
        }, '*');
      }
      if (event.data.type === 'HEIGHT_CHANGED') {
        if (iframeRef.current) {
          iframeRef.current.style.height = `${event.data.height}px`;
        }
      }
      if (event.data.type === 'VALUE_CHANGED') {
        onChangeRef.current(event.data.value);
      }
    };
    window.addEventListener('message', handler);
    return () => window.removeEventListener('message', handler);
  }, [fieldId]);
  return /*#__PURE__*/React.createElement("iframe", {
    ref: iframeRef,
    title: "Widget",
    sandbox: "allow-scripts",
    srcDoc: widgetHtml.replace('{{FIELD_ID}}', fieldId),
    style: {
      border: 'none',
      width: '100%',
      height: '100%'
    }
  });
};
//# sourceMappingURL=widget.js.map